import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import PageLoader from '../../components/PageLoader/PageLoader'
import Paginate from '../../components/pagination/paginate'
import Select from 'react-select'
import { appGetAllSanstha } from '../../store/sanstha'
import { appDeleteProject, appGetAllProject } from '../../store/socialproject'
import { appGetAllProjectCategory } from '../../store/projectcategory'
import { appAllGetSocialProjectBooking } from '../../store/socialprojectbooking'
import PostPreview from '../../components/PostPreview/PostPreview'
import { toCamelCase } from '../../utils/Function'

function TableFilter({ setExportFilters }) {
	const dispatch = useDispatch()
	const params = useParams()
	const navigate = useNavigate()
	const isloder = useSelector(state => state?.socialprojectReducer.isloder)
	const paginate = useSelector(state => state.socialprojectReducer.paginate)
	const isdeleted = useSelector(state => state?.socialprojectReducer?.isdeleted)
	const { sanstha } = useSelector(state => state.sansthaReducer)
	const [page, setPage] = useState(params.page || 1)
	const [selectedFilters, setSelectedFilters] = useState({
		hub: null,
		sanstha: null,
		category: null,

		status: '',
	})
	const [activeFilters, setActiveFilters] = useState({})
	const [showProjectDetailsModal, setShowProjectDetailsModal] = useState(false)
	const [selectedProject, setSelectedProject] = useState(null)
	const socialproject = useSelector(state => state.socialprojectReducer.socialproject)
	const projectcategory = useSelector(state => state?.projectcategoryReducer?.projectcategory)
	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	useEffect(() => {
		const params = {
			page,
			limit: 10,
			hub: hubId || permissionOfHub,
			...activeFilters,
		}

		dispatch(appGetAllProject(params))
		navigate(`/social-project/${page}`)
	}, [page, activeFilters, hubId, permissionOfHub, dispatch, navigate])

	useEffect(() => {
		if (isdeleted) {
			setPage(1)
		}
	}, [isdeleted])

	useEffect(() => {
		dispatch(appGetAllSanstha({ page: 1, limit: 1000, loading: false }))
		dispatch(
			appGetAllProjectCategory({
				page: 1,
				limit: 1000,
				hub: hubId || permissionOfHub,
				loading: false,
			}),
		)
	}, [page])

	const handleDeletePost = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this social project?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(appDeleteProject(id))
			}
		})
	}

	const handleSearch = useCallback(() => {
		const filters = {}

		if (selectedFilters.hub) filters.hub = selectedFilters.hub.value
		if (selectedFilters.sanstha) filters.sanstha = selectedFilters.sanstha.value
		if (selectedFilters.category) filters.category = selectedFilters.category.value
		if (selectedFilters.status) filters.status = selectedFilters.status

		setActiveFilters(filters)
		setExportFilters(filters)
		setPage(1)
	}, [selectedFilters])

	const handleShowSocialProjectDetails = async projectId => {
		try {
			setSelectedProject(null)

			const projectData = socialproject.data.find(project => project._id === projectId)

			if (!projectData) {
				console.error('Project not found for ID:', projectId)
				return
			}

			const bookingRes = await dispatch(
				appAllGetSocialProjectBooking({ page: 1, limit: 1000, projectId }),
			).unwrap()

			const paymentData = bookingRes?.data || []

			const selectedData = {
				project: projectData,
				payments: paymentData,
			}

			setSelectedProject(selectedData)

			setTimeout(() => {
				//console.log('selectedProject (updated):', selectedData)
			}, 0)

			setShowProjectDetailsModal(true)
		} catch (error) {
			console.error('Error fetching project details:', error)
		}
	}

	const handleCloseModal = () => {
		setShowProjectDetailsModal(false)
		setSelectedProject(null)
	}

	return (
		<>
			{/* {isloder && <PageLoader />} */}
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="row">
						<div className="col-md-2">
							<div className="form-group">
								<label>Sanstha</label>
								<Select
									options={
										Array.isArray(sanstha)
											? sanstha.map(sanstha => ({
													value: sanstha._id,
													label: toCamelCase(sanstha?.name),
											  }))
											: []
									}
									onChange={option => {
										setSelectedFilters(prev => ({
											...prev,
											sanstha: option,
										}))
									}}
									value={selectedFilters.sanstha}
									placeholder="Select Sanstha.."
									getOptionLabel={option => option?.name || option?.label}
									getOptionValue={option => option?._id || option?.value}
								/>
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>Category</label>
								<Select
									options={
										Array.isArray(projectcategory?.data)
											? projectcategory?.data.map(category => ({
													value: category._id,
													label: toCamelCase(category?.name),
											  }))
											: []
									}
									onChange={option => {
										setSelectedFilters(prev => ({
											...prev,
											category: option,
										}))
									}}
									styles={{
										option: provided => ({
											...provided,
											textTransform: 'capitalize',
										}),
									}}
									value={selectedFilters.category}
									placeholder="Select category.."
									getOptionLabel={option => option?.name || option?.label}
									getOptionValue={option => option?._id || option?.value}
								/>
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>Status</label>
								<select
									className="form-control"
									name="status"
									value={selectedFilters.status}
									onChange={e => {
										setSelectedFilters(prev => ({
											...prev,
											status: e.target.value,
										}))
									}}
								>
									<option value="">Select status</option>
									<option value="Upcoming">Upcoming</option>
									<option value="Active">Active</option>
									<option value="Completed">Completed</option>
								</select>
							</div>
						</div>

						<div className="d-flex" style={{ alignItems: 'center', marginTop: '12px' }}>
							<button
								className="btn btn-primary mr-2"
								onClick={handleSearch}
								style={{ marginRight: '8px' }}
							>
								<em className="fas fa-search"></em> Search
							</button>
							<button
								className="btn btn-secondary"
								onClick={() => {
									setSelectedFilters({
										hub: null,
										sanstha: null,
										category: null,
										status: '',
									})
									setPage(1)
									setExportFilters({})
									setActiveFilters({})
								}}
							>
								<em className="fas fa-redo"></em> Reset
							</button>
						</div>
					</div>

					<div className="table-responsive bootgrid">
						<table className="table table-hover" id="bootgrid-command">
							<thead>
								<tr>
									<th>Image</th>
									<th>Project Title</th>
									<th>Category </th>
									<th>Community</th>
									<th>Sanstha</th>
									<th>Received Amount (Rs)</th>
									<th>Start Date</th>
									<th>End Date</th>
									<th>Status</th>
									<th data-column-id="commands" data-formatter="commands" data-sortable="false">
										<div></div>
									</th>
								</tr>
							</thead>
							{socialproject?.data &&
								socialproject?.data.map((value, index) => {
									return (
										<tbody key={index}>
											<tr>
												<td>
													{' '}
													<PostPreview value={value.file} />
												</td>
												<td
													style={{
														maxWidth: '150px',
														wordWrap: 'break-word',
														whiteSpace: 'normal',
														textTransform: 'capitalize',
													}}
												>
													{value?.title}
												</td>
												<td style={{ textTransform: 'capitalize' }}>{value.category.name}</td>
												<td
													style={{
														maxWidth: '150px',
														wordWrap: 'break-word',
														whiteSpace: 'normal',
														textTransform: 'capitalize',
													}}
												>
													{value?.hub ? (
														<>
															<PostPreview value={value?.hub?.image} />

															{toCamelCase(value?.hub?.name)}
														</>
													) : null}
												</td>
												<td
													style={{
														maxWidth: '150px',
														wordWrap: 'break-word',
														whiteSpace: 'normal',
														textTransform: 'capitalize',
													}}
												>
													{value?.sanstha ? (
														<>
															<PostPreview value={value?.sanstha?.image} />

															{toCamelCase(value?.sanstha?.name)}
														</>
													) : null}
												</td>
												<td style={{ textAlign: 'center' }}>{value?.receivedAmount ?? 0}</td>
												<td>
													{' '}
													{new Date(value.startDate).toLocaleDateString('en-US', {
														year: 'numeric',
														month: 'short',
														day: 'numeric',
													})}
												</td>
												<td>
													{value.endDate
														? new Date(value.endDate).toLocaleDateString('en-US', {
																year: 'numeric',
																month: 'short',
																day: 'numeric',
														  })
														: null}
												</td>
												<td>
													<span
														className={`badge ${
															value?.status === 'Upcoming'
																? 'badge-warning'
																: value?.status === 'Active'
																? 'badge-success'
																: value?.status === 'Completed'
																? 'badge-danger'
																: 'badge-light'
														}`}
													>
														{value?.status || 'N/A'}
													</span>
												</td>

												<td>
													<button
														type="button"
														className="btn btn-sm btn-info mr-2 command-edit"
														data-row-id="10253"
														onClick={() =>
															navigate(`/social-project/edit/${value?._id}`, {
																state: { project: value },
															})
														}
													>
														<em className="fa fa-edit fa-fw"></em>
													</button>
													<button
														onClick={e => {
															e.preventDefault()
															e.stopPropagation()
															handleShowSocialProjectDetails(value?._id)
														}}
														className="btn btn-sm btn-primary mr-2"
														title="Details"
													>
														<em className="fa fa-eye fa-fw"></em>
													</button>
													<button
														type="button"
														className="btn btn-sm btn-danger command-delete"
														data-row-id="10253"
														onClick={() => handleDeletePost(value?._id)}
													>
														<em className="fa fa-trash fa-fw"></em>
													</button>
												</td>
											</tr>
										</tbody>
									)
								})}
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>

			{showProjectDetailsModal && selectedProject && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog modal-lg">
						<div className="modal-content shadow-lg rounded-3">
							<div className="modal-header bg-primary text-white">
								<h5 className="modal-title">Project Payment Details</h5>
								<button
									type="button"
									className="btn-close btn-close-white"
									onClick={handleCloseModal}
								></button>
							</div>

							<div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
								<div className="text-center mb-4">
									<h4 className="fw-bold text-primary">
										<strong>Social Project:</strong> {selectedProject.project?.title}
									</h4>
									<div
										style={{ flex: 1, fontSize: '16px' }}
										dangerouslySetInnerHTML={{
											__html:
												selectedProject.project?.description || '<i>No description available</i>',
										}}
									/>
								</div>

								<div className="row text-center mb-4">
									<div className="col-md-6 mb-3">
										{selectedProject?.project?.hub && (
											<>
												<img
													src={selectedProject?.project.hub?.image}
													alt="Hub Logo"
													className="rounded-circle border border-2"
													style={{
														width: '50px',
														height: '50px',
														objectFit: 'cover',
													}}
												/>
												<p className="fw-bold mt-2 mb-0">{selectedProject?.project?.hub?.name}</p>
												<small className="text-muted">Community</small>
											</>
										)}
									</div>

									<div className="col-md-6 mb-3">
										{selectedProject?.project?.sanstha && (
											<>
												<img
													src={selectedProject?.project?.sanstha?.image}
													alt="Sanstha Logo"
													className="rounded-circle border border-2"
													style={{
														width: '50px',
														height: '50px',
														objectFit: 'cover',
													}}
												/>
												<p className="fw-bold mt-2 mb-0">
													{selectedProject?.project?.sanstha?.name}
												</p>
												<small className="text-muted">Sanstha</small>
											</>
										)}
									</div>
								</div>

								<div className="row align-items-center  p-3 mb-3">
									<div className="col-md-6 mb-3 mb-md-0 text-center">
										{selectedProject?.project?.file?.startsWith('http') ? (
											<>
												<strong className="d-block mb-2">Payment Screenshot:</strong>

												<img
													src={selectedProject?.project?.file}
													alt="Payment Screenshot"
													className="img-fluid "
													style={{ maxHeight: '100px', objectFit: 'contain' }}
												/>
											</>
										) : (
											<span className="text-muted">N/A</span>
										)}
									</div>
									<div className="col-md-6 text-center">
										<div className="mb-2">
											<strong>Category:</strong> {selectedProject?.project?.category?.name || 'N/A'}
										</div>

										<div className="d-inline-flex align-items-center gap-2">
											<strong>Status: </strong>{' '}
											<span
												className={`badge ${
													selectedProject?.project?.status === 'Upcoming'
														? 'badge-warning'
														: selectedProject?.project?.status === 'Active'
														? 'badge-success'
														: selectedProject?.project?.status === 'Completed'
														? 'badge-danger'
														: 'badge-light'
												}`}
											>
												{selectedProject?.project?.status || 'N/A'}
											</span>
										</div>
									</div>
								</div>

								{selectedProject?.payments?.length > 0 && (
									<div className="table-responsive mt-4">
										<h6 className="fw-bold text-primary mb-3">Payment History</h6>
										<table className="table table-bordered table-hover align-middle">
											<thead className="table-light">
												<tr>
													<th>Date</th>
													<th>User</th>
													<th>Amount</th>
													<th>Mode</th>
												</tr>
											</thead>
											<tbody>
												{selectedProject.payments && selectedProject.payments.length > 0 ? (
													selectedProject.payments.map((payment, index) => (
														<tr key={index}>
															<td>
																{new Date(payment.resolveDate).toLocaleDateString('en-US', {
																	year: 'numeric',
																	month: 'short',
																	day: 'numeric',
																})}
															</td>
															<td>
																<img
																	src={payment.userId?.profilePic || '/img/user.jpg'}
																	alt="user"
																	style={{
																		width: '50px',
																		height: '50px',
																		borderRadius: '50%',
																	}}
																/>
																<br />
																{payment.userId.firstName} {payment.userId.lastName}
																<br />
																<small>{payment.userId.mobile}</small>
															</td>
															<td>₹{payment.amount}</td>
															<td> {payment.isOffline ? 'Offline' : 'Online'}</td>
														</tr>
													))
												) : (
													<tr>
														<td colSpan="5" className="text-center text-muted">
															No payment records available.
														</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>
								)}
							</div>

							<div className="modal-footer">
								<button className="btn btn-secondary px-4" onClick={handleCloseModal}>
									Close
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default TableFilter
